export const ACCESS_TOKEN = 'LFHAccessToken';
export const CREATE_MODE = 'CREATE';
export const EDIT_MODE = 'EDIT';
export const VIEW_MODE = 'VIEW';
export const EMPTY_STRING = '';
export const ALL = 'All';
export const DASHED = '-';
export const DOT = '.';
export const MANDATORY_FIELD_MSG = 'Cannot be empty';
export const NA = 'N/A';
export const DAYS_YEAR = 364;
export const DAYS_QTR = 90;
export const DAYS_MONTH = 30;
export const PAGE_SIZE = 100;
export const UOM_SELECT_ITEMS = ['1,000 Stitch', 'Cm', 'Count', 'Cu Cm', 'Cu Ft', 'Cu Mtr', 'Dozen', 'Feet', 'Gm', 'Gross', 'Inch', 'Kg', 'Mm', 'Mtr', 'Pack', 'Pc', 'Sq Cm', 'Sq Inch', 'Sq Mtr', 'Yard']
export const TYPE_MATERIAL = 'Material';
export const TYPE_PROCESS = 'Process';
export const TYPE_LABOR = 'Labor';
export const INPUT_SELECT_ITEMS = [TYPE_MATERIAL, TYPE_PROCESS, TYPE_LABOR];
export const LABOR_INPUT = ['Checking (Made-up)', 'Checking (Fabric)', 'Packing (Made-up)', 'Packing (Fabric)', 'Bale Packing']
export const COSTING_TYPE_SELECT_ITEMS = ['MOQ', 'Production', 'Sampling'];
export const COST_OWNER_SELECT_ITEMS = ['Customer', 'LFH Home'];
export const CUSTOMER_TYPE_SELECT_ITEMS = ['Domestic', 'Export'];
export const PRODUCT_SELECT_ITEMS = ['Garment', 'Garment Fabric', 'Home Fabric', 'Made-up'];
export const ENQ_CONV_STATUS_ITEMS = ['Open', 'Converted', 'Not Converted'];
export const ENQ_STATUS_ITEMS = ['New', 'In Progress', 'Completed'];
export const ORDER_STATUS_SELECT_ITEMS = ['New', 'In Progress', 'Completed'];
export const ORDER_TYPE_SELECT_ITEMS = ['Sampling', 'Production'];
export const DISPOSAL_ACCOUNT = 'Disposal Account';
export const LFH_HOME = 'LFH Home Private Limited';
export const PL_ACCOUNT = 'Process Loss Account';
export const GENERAL_ACCOUNT = 'General Account';
export const SAMPLING_ACCOUNT = 'Sampling Account';
export const LOGO = 'https://static.wixstatic.com/media/4f434f_f44482ad9bf14d5e83f1a351d8f9e6b7~mv2.png/v1/fill/w_346,h_206,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/4f434f_f44482ad9bf14d5e83f1a351d8f9e6b7~mv2.png';

export const GET_ALL_PRODUCT_URL = '/product/getall';
export const GET_ALL_CUSTOMER_URL = '/customer/getall';
export const GET_ALL_SUPPLIER_URL = '/supplier/getall';
export const GET_ALL_TRANSPORTER_URL = '/supplier/transport'
export const GET_EMPLOYEES_URL = '/user/getactive';
export const GET_SUPERVISOR_URL = '/user?ownership=Supervision';
export const GET_GEN_TASK_URL = '/user?ownership=GeneralTask';
export const GET_TASK_URL = '/production/getallprocesses';
export const GET_SPEC_URL = '/masterdata/specvalue?';
export const GET_MAT_COMP_URL = '/masterdata/specvalue?input=Any&spec=Material Composition';
export const GET_COL_COMP_URL = '/masterdata/specvalue?input=Any&spec=Color Composition';
export const GET_CERT_URL = '/masterdata/specvalue?input=Any&spec=Certification';
export const GET_COUNT_URL = '/masterdata/specvalue?input=Any&spec=Count';
export const GET_COLOR_URL = '/masterdata/specvalue?input=Any&spec=Color';
export const GET_QUALITY_URL = '/masterdata/specvalue?input=Any&spec=Quality';
export const GET_AMZ_TRN_TYPE_URL = '/amazon/transaction/type';
export const GET_AMZ_PRODUCT_URL = '/amazon/inventory/product';
export const GET_STOCK_INPUT = '/order/stock/input'
export const GET_STOCK_ORDER = '/order/stock/order'
